import { render, staticRenderFns } from "./FTPEditor.vue?vue&type=template&id=63cce611&"
import script from "./FTPEditor.vue?vue&type=script&lang=js&"
export * from "./FTPEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports